


//BOLD: Set up the image slider, if it's on the page

window.BOLD = window.BOLD || {};
BOLD.helpers = BOLD.helpers || {};

BOLD.image_slider = {
  defaults:{
    'overlay_images':[],
    'base_images':[],
    'overlay_image_thumbnails':[],
    'base_images_thumbnails':[],
    'container_id':'',
    'title': '',
    'base_selector_title': '',
    'overlay_selector_title': '',
    'direction': 'horizontal',
    'width': 700,
    'height': 450,
    'initial': 30,
    'opacity':1,
    'aspect_ratio':''
  },
  Slider:function(options){
    //Inspired by CATO:  Compare Apples To Oranges - Code by https://github.com/herrfugbaum
    this.options = options = BOLD.helpers.mergeObjects(BOLD.image_slider.defaults, options);

    var init = function(options){
      var container = this.container = document.getElementById(options.container_id);
      if(!container){
        return false;
      }
      var slider = this;

      this.updateElementSizes = function(){
        var aspect_ratio = this.options.aspect_ratio;
        if(aspect_ratio > 0){
          var base = this.base, overlay = this.overlay;
          var visual_width = base.clientWidth;
          var visual_height = visual_width * aspect_ratio;

          base.style.height = visual_height + 'px';
          base.style.backgroundSize = visual_width + 'px ' + visual_height + 'px';
          overlay.style.backgroundSize = visual_width + 'px ' + visual_height + 'px';
          this.updateSliderSize(visual_width, visual_height);
        }
      }
      this.updateSliderSize = function(visual_width, visual_height){
        if(options.direction == 'vertical'){
          slider.className += ' vertical';
          // If the image isn't square, we'll be rotating the slider 90º - swap the height & width so that it's the right size after the rotation
          slider.style.width = visual_height + 'px';
          slider.style.height = visual_width + 'px';
          // If the image isn't square, we need to adjust the position of the rotated slider based on the difference between the height and width
          slider.style.top = ((visual_height - visual_width) * 0.5) + 'px';
          slider.style.left = ((visual_width - visual_height) * 0.5) + 'px';
        }
      }

      this.updateOverlayCoverage = function(evt){
        overlay.style[(options.direction !== 'vertical' ? 'width' : 'height')] = evt.target.value + '%';
      };
      this.createImageSelectorElements = function(img_arr, layer, title, thumbnail_arr){
        var wrapper = document.createElement('div');
        wrapper.className = layer + '-image-selectors';
        if(title){
          var title_element = document.createElement('h3');
          title_element.className = layer + '-image-selector-title image-selector-title';
          title_element.innerText = title;
          wrapper.appendChild(title_element);
        }
        for(var i=0; i<img_arr.length; i++){
          var img = img_arr[i] ||'';
          img = img.trim();
          if(!img_arr[i] || !img_arr[i].trim() || img_arr[i] =='\n'){
            continue;
          }
          var thumbnail = (thumbnail_arr && thumbnail_arr[i] ? thumbnail_arr[i] : '').trim();
          var img_element = this.createImageSelectorElement(img_arr[i], layer, thumbnail);
          if(!this['active_img_' + layer]){
            this['active_img_' + layer] = img_element;
            this[layer].style.backgroundImage = 'url(\'' + img + '\')';
            img_element.className += ' bold-image-selector-active';
          }
          wrapper.appendChild(img_element);
        }
        return wrapper;
      };
      this.createImageSelectorElement = function(data, layer, thumbnail){
        var selector = document.createElement('img');
        selector.src = data.thumbnail || thumbnail || data.url || data;
        selector.setAttribute('alt', data.alt || 'Change ' + layer + ' image');
        selector.className = 'bold-image-selector';
        selector.addEventListener('click', function(evt){
          this['active_img_' + layer].className && (this['active_img_' + layer].className = this['active_img_' + layer].className.split('bold-image-selector-active').join('').trim());
          this['active_img_' + layer] = evt.target;
          evt.target.className += ' bold-image-selector-active';
          this[layer].style.backgroundImage = 'url(\'' +( data.url || data.trim()) + '\')';
        }.bind(this));
        return selector;
      };

      if(options.title){
        var title_element = this.title_element = document.createElement('h2');
        title_element.className = 'image-slider-title';
        title_element.innerText = options.title;
        container.appendChild(title_element);
      }

      var base_images = options.base_images = (typeof options.base_images === 'string' ? options.base_images.split(',') : options.base_images);
      var overlay_images = options.overlay_images = (typeof options.overlay_images === 'string' ? options.overlay_images.split(',') : options.overlay_images);

      var aspect_ratio = options.aspect_ratio;
      if(aspect_ratio && typeof aspect_ratio === 'string'){
        aspect_ratio = aspect_ratio.split(':');
        aspect_ratio[0] && (options.aspect_ratio = aspect_ratio = aspect_ratio[1] / aspect_ratio[0]);
        aspect_ratio > 0 && window.addEventListener('resize', function(evt){
          //Simple debounce to prevent over-calculating
          clearTimeout(this.resizing);
          this.resizing = setTimeout(this.updateElementSizes.bind(this), 50);
        }.bind(this));
      } else {

        var base_image = this.base_image = new Image();
        base_image.src = base_images[0];
        base_image.onload = function(){
          this.options.aspect_ratio = this.options.aspect_ratio || (base_image.height/base_image.width);
          this.updateElementSizes();
          window.addEventListener('resize', function(evt){
            //Simple debounce to prevent over-calculating
            clearTimeout(this.resizing);
            this.resizing = setTimeout(this.updateElementSizes.bind(this), 50);
          }.bind(this));
        }.bind(this);
      }
      var base = this.base = document.createElement('div');
      base.className += ' bold-image-slider-container';
      base.style.width = options.width + (typeof options.width === 'string' && options.width.indexOf('%') === -1 ? 'px' : '');
      base.style.height = options.height + 'px';
      if(base_images.length == 1){
        base.style.backgroundImage = 'url(\'' + base_images[0] + '\')';
      }
      base.style.backgroundSize = options.width + 'px ' + options.height + 'px';

      var overlay = this.overlay = document.createElement('div');
      overlay.className = 'bold-image-slider-overlay' + (options.direction === 'vertical' ? ' vertical' : '');
      overlay.style.width = (options.direction !== 'vertical' ? options.initial : '100') + '%';
      overlay.style.height = (options.direction !== 'vertical' ? '100' : options.initial) + '%';
      overlay.style.opacity = options.opacity;

      if(overlay_images.length == 1){
        overlay.style.backgroundImage = 'url(\'' + overlay_images[0] + '\')';
      }
      overlay.style.backgroundSize = options.width + 'px ' + options.height + 'px';
      var slider = this.slider = document.createElement('input');
      slider.type = 'range';
      slider.className = 'bold-image-slider-input';

      this.updateSliderSize();

      slider.min = 0;
      slider.max = 100;
      slider.value = options.initial;

      slider.addEventListener('change', this.updateOverlayCoverage);
      slider.addEventListener('input', this.updateOverlayCoverage);
      slider.addEventListener('blur', this.updateOverlayCoverage);

      if(base_images.length > 1){
        container.appendChild(this.createImageSelectorElements(base_images, 'base', options.base_selector_title, options.base_image_thumbnails));
      }
      if(overlay_images.length > 1){
        container.appendChild(this.createImageSelectorElements(overlay_images, 'overlay', options.overlay_selector_title, options.overlay_image_thumbnails));
      }

      container.appendChild(base);
      base.appendChild(overlay);
      base.appendChild(slider);
      aspect_ratio > 0 && this.updateElementSizes();
    }.bind(this);
    return init(options);
  }
}

/* ********************************************************************************
     MISC. HELPER FUNCTIONS
******************************************************************************** */
BOLD.helpers.mergeObjects = function(defaults, settings){
  var newObj = {};
  for(var i=0; i<arguments.length; i++){
    for(var key in arguments[i]){
      newObj[key] = arguments[i][key];
    }
  }
  return newObj;
}

BOLD.helpers.checkCSSPropertySupport = function(property, testValue, options){
  //Based on code from https://stackoverflow.com/a/30041538/2592369
  //Returns the (prefixed) property name if the property/value pair are valid (string)
  //Returns false if the property is not supported

  options = options || {};
  var prefixes = options.prefixes || [ 'webkit', 'moz', 'ms', 'o' ],
  properties = [ property ],
  testElement = document.createElement( options.elementName || 'testelement' );
  //          attribute = testValue; //'polygon(50% 0%, 0% 100%, 100% 100%)';

  // Push the prefixed properties into the array of properties.
  for ( var i = 0, l = prefixes.length; i < l; i++ ) {
    var prefixedProperty = prefixes[i] + base.charAt( 0 ).toUpperCase() + base.slice( 1 ); // remember to capitalize!
    properties.push( prefixedProperty );
  }
  // Interate over the properties and see if they pass two tests.
  for ( var i = 0, l = properties.length; i < l; i++ ) {
    var property = properties[i];
    // Does the property exist on our test object?
    if ( testElement.style[property] === '' ) {
      // Can we set the desired value for this property?
      testElement.style[property] = testValue;
      if ( testElement.style[property] !== '' ) {
        return property;
      }
    }
  }
  return false;
}
